import { Empty } from '@byecode/ui'
import { getAssetUrl } from '@lighthouse/assets'
import { type QrBarcodeBlockAbstract, QrBarcodeEnum } from '@lighthouse/core'
import { BarcodeBox, flexMinSizeStyle, getCursorStyle, QRCodeBox, useApplicationContext } from '@lighthouse/shared'
import React, { memo, useMemo } from 'react'
import styled from 'styled-components'

import { AnimationDecorators } from '../../components'
import { useEffectiveAnchorId } from '../../context'
import { useScrollToAnchorWhenHashMatch } from '../../hooks/useScrollToAnchorWhenHashMatch'

const emptyApplicationImg = getAssetUrl('empty', 'no_content.svg')
interface QrBarcodeBlockProps extends React.ComponentPropsWithoutRef<'div'> {
    blockData: QrBarcodeBlockAbstract
    code: string
}

const SCxEmptyImg = styled.img`
    max-width: 140px;
    width: 100%;
`
const SCxContainer = styled(AnimationDecorators)`
    width: 100%;
`

const QrBarcodeBlock: React.FC<QrBarcodeBlockProps> = ({ blockData, code, style, ...rest }) => {
    const { id, title, config } = blockData
    const { codeType, barWidth, breakPoint, cursor, anchor } = config
    const { anchorId } = anchor || {}
    const effectiveAnchorId = useEffectiveAnchorId(anchorId)
    useScrollToAnchorWhenHashMatch(effectiveAnchorId, anchor)

    const { appId = '' } = useApplicationContext()

    const contentEle = useMemo(() => {
        if (!code) {
            return (
                <Empty
                    style={{ margin: '32px 0' }}
                    icon={<SCxEmptyImg src={emptyApplicationImg} alt="" />}
                    description="请在「右侧栏>配置」中填入条码内容"
                />
            )
        }
        if (codeType === QrBarcodeEnum.BARCODE) {
            return <BarcodeBox code={code} barWidth={barWidth} height={80} />
        }
        return <QRCodeBox code={code} />
    }, [code, codeType, barWidth])

    return (
        <SCxContainer
            blockId={id}
            blockName={title}
            animation={breakPoint?.animation}
            id={effectiveAnchorId}
            {...rest}
            style={{ ...flexMinSizeStyle, ...style, ...getCursorStyle(appId, cursor) }}
        >
            {contentEle}
        </SCxContainer>
    )
}

export default memo(QrBarcodeBlock)
